import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

declare var gtag: Function

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  isBrowser: boolean;
  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);

  }
  analyticsData(itemEvent, gtagData) {
    if (this.isBrowser) {
      gtag('event', itemEvent, gtagData)
    }
  }

  analyticsDataLayer2(eventData: any) {
    if (this.isBrowser) {
      console.log("eventData", eventData);
      gtag('event', 'conversion', eventData);
    }
  }

  analyticsDataLayer(eventData: any) {
    if (this.isBrowser) {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push(eventData);
    }
  }
}
